import React, { useContext } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import { Card } from 'semantic-ui-react';
import CommentForm from '../../Forms/CommentForm';

//globalContext.translations.headerCompletion
// translationsState.noPasswordFilled
// Echanger à propos de ce séjour

/**
 * Components Chat
 * Widget pour le dashboard
 */
const Chat = props => {
  const [globalContext] = useContext(GlobalContext);

  return (
    <Card style={{ height: "300px" }} centered>

      <Card.Header  style={{textAlign: 'center'}}>
        <h4 className="ui header py-3">{globalContext.translations.headerCardChat}</h4>
      </Card.Header>

      <Card.Content style={{textAlign: 'center', height: 'calc( 100% - 68px)'}}>
        <Card.Description>
          <CommentForm folderId={props.folderId} messages={props.messages} height={177} mini />
        </Card.Description>
      </Card.Content>

      
    </Card>
  )
}

export default Chat;